/**
=========================================================
* Material Dashboard 2 React - v2.1.0
=========================================================

* Product Page: https://www.creative-tim.com/product/material-dashboard-react
* Copyright 2022 Creative Tim (https://www.creative-tim.com)

Coded by www.creative-tim.com

 =========================================================

* The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software.
*/

/** 
  All of the routes for the Material Dashboard 2 React are added here,
  You can add a new route, customize the routes and delete the routes here.

  Once you add a new route on this file it will be visible automatically on
  the Sidenav.

  For adding a new route you can follow the existing routes in the routes array.
  1. The `type` key with the `collapse` value is used for a route.
  2. The `type` key with the `title` value is used for a title inside the Sidenav. 
  3. The `type` key with the `divider` value is used for a divider between Sidenav items.
  4. The `name` key is used for the name of the route on the Sidenav.
  5. The `key` key is used for the key of the route (It will help you with the key prop inside a loop).
  6. The `icon` key is used for the icon of the route on the Sidenav, you have to add a node.
  7. The `collapse` key is used for making a collapsible item on the Sidenav that has other routes
  inside (nested routes), you need to pass the nested routes inside an array as a value for the `collapse` key.
  8. The `route` key is used to store the route location which is used for the react router.
  9. The `href` key is used to store the external links location.
  10. The `title` key is only for the item with the type of `title` and its used for the title text on the Sidenav.
  10. The `component` key is used to store the component of its route.
*/

// @mui icons
import Icon from '@mui/material/Icon'

// Material Dashboard 2 React layouts
import Dashboard from './dashboard'
// import Tables from './tables'
// import Billing from './billing'
// import Notifications from './notifications'
import Profile from './profile'
import PropertyTypes from './PropertyTypes'
import Propertystyle from './Propertystyle'
import Priceperhour from './Priceperhour'
import Features from './Features'
import Spacetypes from './Spacetypes'
import Users from './Users'
import Listing from './Listing'
import BookingForm from './booking'
import SimpleCKEditor from './content'

import Bookings from "./Bookings"
import Blogs from './Blogs'
import LinkInBio from './LinkInBio'
import Collections from './Collections'
import HeaderBanner from './HeaderBanner'
import ChangeRequestDetailPage from './Bookings/components/data-tables/ChangeRequestDetailPage'
import SearchAnalyticsDashboard from './SearchAnalytics'
import FilesManager from './Files'
import BoostListings from './BoostListings'
import BookingLedger from './BookingLedger'
import WeeklyEmailsPage from './WeeklyEmails'
import SiteNotifications from './SiteNotifications'
import ChatBotConfig from './ChatBotConfig'
import CreativeDirectory from './CreativeDirectory'
import CreativeDirectoryDetail from './CreativeDirectory/detail'
import CreativeDirectoryAnalytics from './CreativeDirectory/analytics'
import CreativeDirectoryAnalyticsDetail from './CreativeDirectory/analyticsDetail'
import DirectoryOptions from './DirectoryOptions'
import GeoAllowlist from './GeoAllowlist'
import MonthlyRecap from './MonthlyRecap'
import ConversationPriority from './ConversationPriority'


function useRoutes() {
  return [
    {
      type: 'collapse',
      name: 'Dashboard',
      key: 'dashboard',
      icon: <Icon fontSize="small">dashboard</Icon>,
      route: '/dashboard',
      component: <Dashboard />,
    },
    {
      type: 'collapse',
      name: 'Recap the Month',
      key: 'monthly-recap',
      icon: <Icon fontSize="small">insights</Icon>,
      route: '/monthly-recap',
      component: <MonthlyRecap />,
    },
    {
      type: 'collapse',
      name: 'Conversation Priorities',
      key: 'conversation-priority',
      icon: <Icon fontSize="small">priority_high</Icon>,
      route: '/conversation-priority',
      component: <ConversationPriority />,
    },
    {
      type: 'collapse',
      name: 'Property Type',
      key: 'propertytypes',
      icon: <Icon fontSize="small">person</Icon>,
      route: '/propertytypes',
      component: <PropertyTypes />,
    },
    {
      type: 'collapse',
      name: 'Style',
      key: 'propertystyle',
      icon: <Icon fontSize="small">person</Icon>,
      route: '/propertystyle',
      component: <Propertystyle />,
    },
    {
      type: 'collapse',
      name: 'Price Per Hour',
      key: 'priceperhour',
      icon: <Icon fontSize="small">person</Icon>,
      route: '/priceperhour',
      component: <Priceperhour />,
    },
    {
      type: 'collapse',
      name: 'Features',
      key: 'features',
      icon: <Icon fontSize="small">person</Icon>,
      route: '/features',
      component: <Features />,
    },
    {
      type: 'collapse',
      name: 'Space Types',
      key: 'spacetypes',
      icon: <Icon fontSize="small">person</Icon>,
      route: '/spacetypes',
      component: <Spacetypes />,
    },
    {
      type: 'collapse',
      name: 'Users',
      key: 'users',
      icon: <Icon fontSize="small">person</Icon>,
      route: '/users',
      component: <Users />,
    },
    {
      type: 'collapse',
      name: 'Listing',
      key: 'listing',
      icon: <Icon fontSize="small">person</Icon>,
      route: '/listing',
      component: <Listing />,
    },
    //  {
    //   type: 'collapse',
    //   name: 'Booking',
    //   key: 'booking',
    //   icon: <Icon fontSize="small">person</Icon>,
    //   route: '/',
    //   component: <BookingForm/>,
    // },
    {
      type: 'collapse',
      name: 'Pages Content',
      key: 'content',
      icon: <Icon fontSize="small">person</Icon>,
      route: '/content',
      component: <SimpleCKEditor />,
    },
    {
      type: 'collapse',
      name: 'Bookings',
      key: 'Bookings',
      icon: <Icon fontSize="small">person</Icon>,
      route: '/Bookings',
      component: <Bookings />,
    },
    {
      type: 'collapse',
      name: 'Payment Management',
      key: 'PaymentManagement',
      icon: <Icon fontSize="small">receipt_long</Icon>,
      route: '/payment-management',
      component: <BookingLedger />,
    },
    {
      type: 'collapse',
      name: 'Blogs',
      key: 'Blogs',
      icon: <Icon fontSize="small">person</Icon>,
      route: '/blogs',
      component: <Blogs />,
    },
    {
      type: 'collapse',
      name: 'Link in Bio',
      key: 'LinkInBio',
      icon: <Icon fontSize="small">link</Icon>,
      route: '/link-in-bio',
      component: <LinkInBio />,
    },
    {
      type: 'collapse',
      name: 'Collections',
      key: 'Collections',
      icon: <Icon fontSize="small">person</Icon>,
      route: '/collections',
      component: <Collections />,
    },
    {
      type: 'collapse',
      name: 'Hero Section',
      key: 'Hero Section',
      icon: <Icon fontSize="small">person</Icon>,
      route: '/hero-section',
      component: <HeaderBanner />,
    },
    {
      type: 'collapse',
      name: 'Trends',
      key: 'Trends',
      icon: <Icon fontSize="small">person</Icon>,
      route: '/trends',
      component: <SearchAnalyticsDashboard />,
    },
    {
      type: 'collapse',
      name: 'Files Upload',
      key: 'Files',
      icon: <Icon fontSize="small">person</Icon>,
      route: '/files',
      component: <FilesManager />,
    },
    {
      type: 'collapse',
      name: 'Boost Listings',
      key: 'BoostListings',
      icon: <Icon fontSize="small">rocket_launch</Icon>,
      route: '/boost-listings',
      component: <BoostListings />,
    },
    {
      type: 'collapse',
      name: 'Weekly Emails',
      key: 'WeeklyEmails',
      icon: <Icon fontSize="small">mail</Icon>,
      route: '/weekly-emails',
      component: <WeeklyEmailsPage />,
    },
    {
      type: 'collapse',
      name: 'Notifications',
      key: 'SiteNotifications',
      icon: <Icon fontSize="small">campaign</Icon>,
      route: '/site-notifications',
      component: <SiteNotifications />,
    },
    {
      type: 'collapse',
      name: 'Chat Assistant',
      key: 'ChatBotConfig',
      icon: <Icon fontSize="small">forum</Icon>,
      route: '/chat-assistant',
      component: <ChatBotConfig />,
    },

    {
      route: '/Bookings/change-request/:bookingNo',
      component: <ChangeRequestDetailPage />,

    },
      {
          type      : 'collapse',
          name      : 'Creative Directory',
          key       : 'creative-directory',
          icon      : <Icon fontSize="small">groups</Icon>,
          route     : '/creative-directory',
          component : <CreativeDirectory />,
        },
      {
          type      : 'collapse',
          name      : 'Directory Analytics',
          key       : 'creative-directory-analytics',
          icon      : <Icon fontSize="small">bar_chart</Icon>,
          route     : '/creative-directory/analytics',
          component : <CreativeDirectoryAnalytics />,
        },
      {
          // Per-listing analytics detail (reached from the analytics table).
          route     : '/creative-directory/:id/analytics',
          component : <CreativeDirectoryAnalyticsDetail />,
        },
      {
          // Moderation detail page (reached from the directory table).
          route     : '/creative-directory/:id',
          component : <CreativeDirectoryDetail />,
        },
      {
          type      : 'collapse',
          name      : 'Directory Options',
          key       : 'directory-options',
          icon      : <Icon fontSize="small">tune</Icon>,
          route     : '/directory-options',
          component : <DirectoryOptions />,
        },
      {
          type      : 'collapse',
          name      : 'Region Bypass IPs',
          key       : 'geo-allowlist',
          icon      : <Icon fontSize="small">public</Icon>,
          route     : '/geo-allowlist',
          component : <GeoAllowlist />,
        },

  ]
}

export default useRoutes
